module.exports = __webpack_public_path__ + "static/img/数据.0d74b66.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Help/数据.gif
// module id = gL7F
// module chunks = 3